import useProfile from '@/hooks/use-profile'
export type PlanType =
  | 'essentials-plan-monthly'
  | 'growth-plan-monthly'
  | 'growth-plan-annual'
  | 'business-plan-annual'
  | 'business-plan-monthly'
  | 'business-plan-special'
  | 'growth-plan-monthly-coupon-wbrothers'

const useGetPlanKey = () => {
  const profile = useProfile()
  const currentPlan = profile?.company_info?.base_plan_name as PlanType

  const plans: any = {
    'essentials-plan-monthly': 'essentials',
    'growth-plan-monthly': 'growth',
    'growth-plan-annual': 'growth',
    'business-plan-annual': 'business',
    'business-plan-monthly': 'business',
    'business-plan-special': 'business',
    'growth-plan-monthly-coupon-wbrothers': 'growth'
  }
  return plans[currentPlan] ?? 'essentials'
}

export default useGetPlanKey
